import { checkList, switchSteps } from "../content";

export default function Guide() {
  return (
    <div className="bg-background-100/70">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
        {/* 互换方法 */}
        <section id="switch" className="scroll-mt-20">
          <div className="grid grid-cols-1 items-start gap-6 lg:grid-cols-12">
            <div className="lg:col-span-5">
              <p className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm font-medium text-primary-700">
                <i className="ri-arrow-left-right-line" /> 互换方法
              </p>
              <h2 className="mt-4 text-2xl font-bold text-foreground-950 md:text-4xl">
                吃瓜网址多个地址，怎么切最顺
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
                别再东点一下西点一下。把下面 4 步记牢，遇到主站打不开时照着走，
                吃瓜网址地址互换也就几十秒的事，切换过程不慌也不乱。
              </p>
              <a
                href="#faq"
                className="mt-6 inline-flex items-center whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
              >
                还有疑问？看常见问题
                <i className="ri-arrow-right-line ml-1" />
              </a>
            </div>

            <ol className="space-y-4 lg:col-span-7">
              {switchSteps.map((s, i) => (
                <li key={s.step} className="flex gap-4 rounded-2xl border border-background-200 bg-background-50 p-5">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-500 text-xl text-background-50">
                    <i className={s.icon} />
                  </span>
                  <div className="flex-1">
                    <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-primary-600">
                      0{i + 1} · {s.step}
                    </span>
                    <h3 className="mt-1 text-lg font-bold text-foreground-950">{s.title}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </section>

        {/* 可用检测 */}
        <section id="check" className="mt-16 scroll-mt-20 md:mt-24">
          <div className="mx-auto max-w-2xl text-center">
            <p className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-sm font-medium text-accent-800">
              <i className="ri-radar-line" /> 可用检测
            </p>
            <h2 className="mt-4 text-2xl font-bold text-foreground-950 md:text-4xl">
              怎么判断哪个地址真的能开
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              不用一个个盲试。对照下面 4 个检测点快速过一遍，吃瓜网址哪个能开、哪个更稳，心里立刻有数。
            </p>
          </div>

          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {checkList.map((c, idx) => (
              <article key={c.title} className="rounded-2xl border border-background-200 bg-background-50 p-6">
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-100 text-xl text-accent-700">
                    <i className={c.icon} />
                  </span>
                  <span className="font-heading text-3xl font-black text-accent-500/30">0{idx + 1}</span>
                </div>
                <h3 className="mt-4 text-base font-bold text-foreground-950 md:text-lg">{c.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              </article>
            ))}
          </div>

          <div className="mx-auto mt-10 max-w-3xl overflow-hidden rounded-3xl bg-foreground-900 text-background-50">
            <div className="grid grid-cols-1 md:grid-cols-2">
              <div className="p-7 md:p-9">
                <h3 className="text-xl font-bold text-background-50 md:text-2xl">一次可用检测，约 1 分钟</h3>
                <p className="mt-3 text-sm leading-relaxed text-background-200">
                  建议每周挑一个固定时间，把主用地址的打开速度、新鲜度、稳定性快速过一遍，再顺手把新入口升级，清单永远保持最佳状态。
                </p>
                <a
                  href="#address"
                  className="mt-6 inline-flex items-center whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
                >
                  去地址汇总里实测
                  <i className="ri-arrow-right-line ml-2" />
                </a>
              </div>
              <div className="border-t border-foreground-800 p-7 md:border-l md:border-t-0 md:p-9">
                <h4 className="text-sm font-semibold uppercase tracking-wide text-background-300">检测四问</h4>
                <ul className="mt-4 space-y-4">
                  <li className="flex gap-3">
                    <i className="ri-checkbox-circle-line text-accent-400" />
                    <span className="text-sm text-background-100">打开速度是否在正常范围？</span>
                  </li>
                  <li className="flex gap-3">
                    <i className="ri-checkbox-circle-line text-accent-400" />
                    <span className="text-sm text-background-100">内容是否有最近的更新？</span>
                  </li>
                  <li className="flex gap-3">
                    <i className="ri-checkbox-circle-line text-accent-400" />
                    <span className="text-sm text-background-100">状态是否标注为「可用」？</span>
                  </li>
                  <li className="flex gap-3">
                    <i className="ri-checkbox-circle-line text-accent-400" />
                    <span className="text-sm text-background-100">连续打开是否稳定不报错？</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}